export const OPEN_CELL = 'OPEN_CELL'
export const SET_FLAG = 'SET_FLAG'
export const CHANGE_GAME_STATUS = 'CHANGE_GAME_STATUS'
export const CHANGE_GAME_MODE = 'CHANGE_GAME_MODE'
export const CHANGE_FIELD_SIZE = 'CHANGE_FIELD_SIZE'
export const SET_FIELD = 'SET_FIELD'
export const SET_PLAYER = 'SET_PLAYER'
export const SET_LEADERBOARD = 'SET_LEADERBOARD'
export const SET_GAME_TIME = 'SET_GAME_TIME'
export const RESET_GAME_TIME = 'RESET_GAME_TIME'
